import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "reactstrap";

import axios from "../helpers/axiosConfig";
import { getPrimaryShopId } from "../helpers/shop";
import { setToken } from "../slices/authSlice";

const AuthProtected = (props: any) => {
  const { user } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();

  const [checkingSession, setCheckingSession] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const verifySession = async () => {
      try {
        const response = await axios.get("/api/user", { withCredentials: true });
        const responseData = response?.data ?? response;
        const userData = responseData?.user ?? responseData;

        if (userData && isMounted) {
          const session = { user: userData };
          localStorage.setItem("authUser", JSON.stringify(session));
          dispatch(setToken(session));
        }
      } catch (error) {
        // Intentionally ignore errors and allow redirect to login
      } finally {
        if (isMounted) setCheckingSession(false);
      }
    };

    setCheckingSession(true);
    verifySession();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  if (checkingSession)
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner size="sm" />
      </div>
    );

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isEmailUnverified = user?.email_verified_at == null;
  const isVerifyRoute = location.pathname === "/verify-email";
  const isCreateShopRoute = location.pathname === "/create-shop";
  const isLogoutRoute = location.pathname === "/logout";
  const hasShop = Boolean(getPrimaryShopId(user));

  if (isEmailUnverified && !isVerifyRoute && !isLogoutRoute) {
    return <Navigate to="/verify-email" replace />;
  }

  if (!isEmailUnverified && isVerifyRoute) {
    return <Navigate to="/order" replace />;
  }

  if (!isEmailUnverified && !hasShop && !isCreateShopRoute && !isLogoutRoute) {
    return <Navigate to="/create-shop" replace />;
  }

  if (hasShop && isCreateShopRoute) {
    return <Navigate to="/order" replace />;
  }

  return <>{props.children}</>;
};

export default AuthProtected;
